import { render } from "./AddPaymentPopup.vue?vue&type=template&id=2fb498d5"
import script from "./AddPaymentPopup.vue?vue&type=script&lang=js"
export * from "./AddPaymentPopup.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__